
export default {
  motivoId: {
    value: null,
    options: [],
    required: true,
    state: null
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/modal/lost/cardlostmodal-form.js